var baseModule = require("bassett/product/base");
var workroom = require("bassett/product/workroom");
var workroomHelpers = require("bassett/product/workroomHelpers");

var SELECTORS = {
    CUSTOMIZER_META: ".pdp-customizer-meta",
    CUSTOMIZER_CONTAINER: "#pdp-customizer-container",
    CUSTOMIZER_PREVIEW: "#pdp-customizer-preview",
    MAIN_IMAGES_CONTAINER: ".pdp-images-main-container",
    CUSTOMIZER_PREVIEW_CONTAINER: ".pdp-images-customizer-preview-container",
    ADD_TO_CART_BUTTON: "button.add-to-cart-drive-customizer",
    CHANGE_PRODUCT_PREVIEW_BUTTON: ".pdp-images-change-preview-container",
    CUSTOMIZER_SLIDE: ".slide-inside--customizer"
};

/**
 * Updates wishlist icon
 * as every time customizer attributes are changed new recipe should be generated and may or may not be in the wishlist
 * @param {jQuery} element - element based on which icon should be updated
 * @param {Object} data - the data returned from the AJAX call
 */
function updateWishlistIcon(element, data) {
    var iconEmpty = element.closest(".product-detail .product-main-region").find(".wishlist-add");
    var iconFilled = element.closest(".product-detail .product-main-region").find(".wishlist-remove");
    if (iconEmpty && iconEmpty.length) {
        iconEmpty.toggleClass("d-none", data.isInlist);
    }
    if (iconFilled && iconFilled.length) {
        iconEmpty.data("recipeId", "");
        iconFilled.toggleClass("d-none", !data.isInlist);
    }
}

/**
 * display message on page based on add to list response data
 * @param {string} data - data returned from the server's ajax call
 * @param {string} listName - list name to handle message for
 * @param {Object} button - button that was clicked to add a product to the list (optional)
 * @param {Object} iconEmpty - icon that was clicked to add a product to the wishlist (optional)
 * @param {Object} iconFilled - icon that was clicked to remove a product from the wishlist (optional)
 */
function displayMessage(data, listName, button, iconEmpty, iconFilled) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = "alert-success";
        if (iconEmpty && iconEmpty.length) {
            iconEmpty.toggleClass("d-none");
        }
        if (iconFilled && iconFilled.length) {
            iconFilled.toggleClass("d-none");
        }
    } else {
        status = "alert-danger";
    }

    if ($(".add-to-" + listName + "-messages").length === 0) {
        $("body").append("<div class='add-to-" + listName + "-messages '></div>");
    }
    $(".add-to-" + listName + "-messages").append(
        "<div class='add-to-" + listName + "-alert text-center alert " + status +  "'>" + data.msg + "</div>"
    );

    setTimeout(function () {
        $(".add-to-" + listName + "-messages").remove();
        if (button && button.length) {
            button.removeAttr("disabled");
        }
    }, 5000);
}

/**
 * Returns widget's meta object with get method
 */
function getWidgetMeta() {
    var metaContainer = $(SELECTORS.CUSTOMIZER_META);
    return {
        get: function (attrName) {
            return metaContainer.data(attrName);
        },
        set: function (attrName, attrValue) {
            metaContainer.data(attrName, attrValue);
        }
    };
}

/**
 * Updates prices and promos info on page based on response data
 * @param {Object} response - products response
 */
function updatePricesAndPromotions(response) {
    var salePriceTile = response.driceCustomizerPrice.sales.pdpTileFormat;
    var salePriceDecimal = response.driceCustomizerPrice.sales.decimalPrice;
    var listPriceTile = response.driceCustomizerPrice.list.pdpTileFormat;
    var listPriceDecimal = response.driceCustomizerPrice.list.decimalPrice;

    $(".prices").each(function () {
        $(this).find(".price").find(".sales").find(".synchrony-price-widget").text(salePriceDecimal);
        $(this).find(".price").find(".sales").find(".value").text(salePriceTile).attr("content", salePriceDecimal);
        $(this).find(".price").find(".list").find(".synchrony-price-widget").text(listPriceDecimal);
        $(this).find(".price").find(".list").find(".value").text(listPriceTile).attr("content", listPriceDecimal);

        var salesPriceFloat = parseFloat(salePriceDecimal);
        var listPriceFloat = parseFloat(listPriceDecimal);
        if (salesPriceFloat < listPriceFloat) {
            $(this).find(".list").removeClass("d-none");
        } else {
            $(this).find(".list").addClass("d-none");
        }
    });
    baseModule.methods.calculateSavings();
    var selectedQty = 1;
    if (response.quantity) {
        selectedQty = response.quantity;
    } else if (response.products && response.products.length > 0 && response.products[0].quantities) {
        response.products[0].quantities.map(function (quantity) { // eslint-disable-line array-callback-return
            if (quantity.selected) {
                selectedQty = quantity.value;
            }
        });
    }
    var priceSelector = $(".cart-and-ipay .prices .price .value");
    var price = Math.round($(priceSelector[0]).text().replace(/[^0-9.-]+/g, ""));
    var finalPrice = price * selectedQty;

    priceSelector.text("$" + finalPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"));
}

/**
 * Updates availability and add to cart button on page based on response data
 * @param {Object} response - products response
 * @param {jQuery} $productContainer - product container element
 */
function updateAvailabilityAndAddToCart(response, $productContainer) {
    var allAvailable = response.products.every(function (product) {
        return product.available;
    });
    var allReadyToOrder = response.products.every(function (product) {
        return product.readyToOrder;
    });
    var disabled = (!allAvailable || !allReadyToOrder);

    $("div.availability", $productContainer)
        .data("ready-to-order", allReadyToOrder)
        .data("available", allAvailable);

    $(SELECTORS.ADD_TO_CART_BUTTON).each(function () {
        $(this).prop("disabled", disabled);
    });

    if (disabled) {
        $(".prices-add-to-cart-actions", $productContainer).addClass("disabled-actions");
    } else {
        $(".prices-add-to-cart-actions", $productContainer).removeClass("disabled-actions");
    }
}

/**
 * Updates specifications based on response data
 * @param {Object} response - products response
 * @param {jQuery} $productContainer - product container element
 */
function updateSpecifications(response, $productContainer) {
    if ((!response.products || response.products.length !== 1) && !response.bundleProduct) {
        return;
    }

    var product = response.products && response.products.length === 1 ? response.products[0] : response.bundleProduct;

    var responseObject = {
        product: product,
        $productContainer: $productContainer
    };

    $("body").trigger("product:statusUpdate", responseObject);
}

/**
 * Handles Change Sku Response
 * @param {Object} response - products response
 * @param {jQuery} $productContainer - product container element
 * @param {Boolean} isVirtualSku - determines if carousel should switch to 360 view
 * @param {Boolean} preventGalleryRefresh - drive flag for stopping gallery refresh
 */
function handleChangeSkuResponse(response, $productContainer, isVirtualSku, preventGalleryRefresh) {
    updatePricesAndPromotions(response);
    updateAvailabilityAndAddToCart(response, $productContainer);
    updateSpecifications(response, $productContainer);
    updateWishlistIcon($(SELECTORS.CUSTOMIZER_CONTAINER), response);
    baseModule.methods.updateProductImages(response, $productContainer, true, isVirtualSku, preventGalleryRefresh);
    baseModule.methods.updateShippingMessage(response);
    var data = {};
    data.product = response.products[0];
    data.driveCustomizerPrice = response.driceCustomizerPrice;
    $("body").trigger("product:afterAttributeSelect", { data: data, container: $productContainer });
}

/**
 * Returns Quantity Selector
 * @returns {jQuery} quantity element
 */
function getQuantitySelector() {
    return $(".quantity-select");
}

/**
 * Returns Quantity value
 * @returns {number} quantity
 */
function getBaseQuantity() {
    var qtyElement = getQuantitySelector();
    var qty = qtyElement ? (qtyElement.val() || 1) : 1;
    return qty;
}

/**
 * Handles Change Sku Ajax
 * @param {string} url - url
 * @param {Object} requestData - requestData
 */
function handleChangeSkuAjax(url, requestData) {
    if (!url || !requestData) {
        return;
    }

    var $savingsContainer = $(".product-detail").find(".attributes .savings");
    var isVirtualSku = requestData.isVirtualSku;
    var preventGalleryRefresh = requestData.preventGalleryRefresh;

    $.ajax({
        url: url,
        method: "POST",
        data: requestData,
        dataType: "json",
        success: function (responseData) {
            if (!responseData.error) {
                var displaySavingsMessage = responseData.displaySavingsMessage;
                $savingsContainer.data("savings-message", displaySavingsMessage);
                handleChangeSkuResponse(responseData, $(".product-detail"), isVirtualSku, preventGalleryRefresh);
                $("body").trigger("gtm:standartEvent", {
                    event: "view_item",
                    data: JSON.parse(responseData.gtmItem)
                });
                var htmlAddToCart = "<div class='gtm-add-to-cart' data-gtm-add-to-cart='" + responseData.gtmItem + "'></div>";
                $(".gtm-add-to-cart-container").empty().html(htmlAddToCart);
                var htmlAddToWishlist = "<div class='gtm-add-to-wishlist' data-add-to-wishlist='" + responseData.gtmItem + "'></div>";
                $(".gtm-add-to-wishlist-container").empty().html(htmlAddToWishlist);
                $("body").trigger("pixel:updateAddToCartSku", responseData);
                $("body").trigger("pinterest:updateAddToCartData", responseData);
            }
        },
        error: function () { }
    });
}

/**
 * Returns callback function for widget initialization options
 */
function getOnSelectedSkuChangedCallback() {
    var meta = getWidgetMeta();
    var loaded = false;

    var onSelectedSkuChangedFunc = function (data) {
        // onSelectedSkuChanged is called on widget load but there is no need to update product preview
        if (!loaded) {
            loaded = true;
        } else {
            $(SELECTORS.CUSTOMIZER_SLIDE).attr("data-loaded", true);
        }

        var url = meta.get("urlProductDetails");

        var requestData = {
            quantity: getBaseQuantity()
        };
        Object.keys(data).forEach(function (key) {
            if (typeof data[key] === "object") {
                requestData[key] = JSON.stringify(data[key]);
            } else {
                requestData[key] = data[key];
            }
        });

        meta.set("skuData", JSON.stringify(requestData));
        handleChangeSkuAjax(url, requestData);
    };

    return onSelectedSkuChangedFunc;
}

/**
 * Returns callback function for widget initialization options
 */
function getOnOrderSwatchCallback() {
    var onOrderSwatchFunc = function (id, type, sku) {
        var addToCartUrl = $(".add-to-cart-url").val();
        var qty = getBaseQuantity();

        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: "POST",
                data: {
                    quantity: qty,
                    pid: sku
                },
                success: function (data) {
                    baseModule.methods.handlePostCartAdd(data);
                    $("body").trigger("product:afterAddToCart", data);
                    $.spinner().stop();
                    baseModule.miniCartReportingUrl(data.reportingURL);
                },
                error: function (err) {
                    baseModule.methods.handlePostCartAdd(err.responseJSON);
                    $.spinner().stop();
                }
            });
        } else {
            $.spinner().stop();
        }
    };
    return onOrderSwatchFunc;
}

/**
 * Returns callback function for widget initialization options
 */
function getOnFavoriteFabricCallback() {
    var meta = getWidgetMeta();
    var onFavoriteFabricFunc = function (sku) {
        var url = meta.get("saveFabricUrl");
        $.spinner().start();
        $.ajax({
            url: url,
            type: "post",
            data: {
                pid: sku
            },
            dataType: "json",
            success: function (response) {
                displayMessage(response, "wishlist");
            },
            error: function (err) {
                displayMessage(err, "wishlist");
            }
        });
    };
    return onFavoriteFabricFunc;
}

/**
 * Returns callback function for widget initialization options
 */
function getOnShowDetailsCallback() {
    var onShowDetailsFunc = function (driveData) {
        if (driveData.sku) {
            var url = $("#pdp-customizer-container").data("url");
            if (url.indexOf("?") > -1) {
                url += "&pid=" + driveData.sku;
            } else {
                url += "?pid=" + driveData.sku;
            }
            workroomHelpers.getModalHtmlElement();
            $("#workroomDetailsModal .modal-body").spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (dwData) {
                    var parsedHtml = workroomHelpers.parseHtml(dwData);
                    $("#workroomDetailsModal .modal-body, #workroomDetailsModal .modal-header").empty();
                    $("#workroomDetailsModal .modal-header").replaceWith(parsedHtml.header);
                    $("#workroomDetailsModal .modal-image").replaceWith(parsedHtml.image);
                    $("#workroomDetailsModal .modal-body").html(parsedHtml.body);
                    if (driveData.priceDifferenceFormatted) {
                        $("#workroomDetailsModal .product-info").append(`<div class="material-details-modal__spec">Price difference: ${driveData.priceDifferenceFormatted}</div>`);
                    }
                    $("#workroomDetailsModal").modal("show");
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    };
    return onShowDetailsFunc;
}

/**
 * Returns widget's options object for widget initialization
 */
function getWidgetOptions() {
    var meta = getWidgetMeta();

    return {
        apiKey: meta.get("apiKey"),
        products: meta.get("product"),
        site: meta.get("site"),
        priceType: meta.get("priceType"),
        recipe: meta.get("editedRecipe"),
        webOnly: meta.get("webOnly"),
        disableCaching: meta.get("disableCaching"),
        container: document.querySelector(SELECTORS.CUSTOMIZER_CONTAINER),
        previewContainer: document.querySelector(SELECTORS.CUSTOMIZER_PREVIEW),
        onSelectedSkuChanged: getOnSelectedSkuChangedCallback(),
        onOrderSwatch: getOnOrderSwatchCallback(),
        onFavoriteFabric: getOnFavoriteFabricCallback(),
        onShowDetails: getOnShowDetailsCallback()
    };
}

/**
 * Handles recipe generation and returns promise object
 * @param {Object} customizerInstance - customizer instance
 * @returns {Promise} promise object
 */
function getRecipe(customizerInstance) {
    return customizerInstance.addToCart();
}

/**
 * Adds recipe to cart and handles server response
 * @param {Object} recipeObj - customizer instance
 */
function addRecipeToCart(recipeObj) {
    var meta = getWidgetMeta();
    var addToCartUrl = meta.get("urlAddToCart");
    var qty = getBaseQuantity();
    var pid = $(".product-detail:not('.bundle-item')").data("pid");
    var editedRecipe = meta.get("editedRecipe");

    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            method: "POST",
            data: {
                recipe: JSON.stringify(recipeObj.recipe),
                selectedSku: JSON.stringify(recipeObj.selectedSku),
                quantity: qty,
                pid: pid,
                masterProductId: meta.get("masterProductId"),
                editedRecipe: editedRecipe
            },
            success: function (data) {
                baseModule.methods.handlePostCartAdd(data);
                $("body").trigger("product:afterAddToCart", data);
                $.spinner().stop();
                baseModule.miniCartReportingUrl(data.reportingURL);
            },
            error: function (err) {
                baseModule.methods.handlePostCartAdd(err.responseJSON);
                $.spinner().stop();
            }
        });
    } else {
        $.spinner().stop();
    }
}

/**
 * Adds recipe to customer list and handles server response
 * @param {Object} recipeObj - customizer instance
 * @param {jQuery} $element - element that triggered add to list event
 */
function addRecipeToList(recipeObj, $element) {
    var meta = getWidgetMeta();
    var listName;
    var url = meta.get("urlSaveRecipe");
    var button = null;
    var iconEmpty = null;
    var iconFilled = null;
    var listType = $element.data("listType") || 10;
    var pid = $element.closest(".product-detail").find(".product-id").html() || $element.data("pid");
    var masterDriveProductID = $(".pdp-customizer-meta").data("master-product-id");
    var isWishlist = (listType == 10);
    var removeRecipeId = "";

    if (isWishlist) {
        listName = "wishlist";
        iconEmpty = $element.closest(".product-detail .product-main-region").find(".wishlist-add");
        iconFilled = $element.closest(".product-detail .product-main-region").find(".wishlist-remove");
    } else {
        listName = "saveForLaterList";
        button = $element;
    }

    if ($element.hasClass("wishlist-remove")) {
        url = meta.get("urlRemoveRecipe");
        removeRecipeId = iconEmpty.data("recipeId");
    }

    if (button && button.length) {
        button.attr("disabled", true);
    }

    $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: {
            recipe: JSON.stringify(recipeObj.recipe),
            selectedSku: JSON.stringify(recipeObj.selectedSku),
            type: listType,
            pid: pid,
            masterProductId: meta.get("masterProductId"),
            editedRecipe: meta.get("editedRecipe"),
            recipeId: removeRecipeId,
            bundleParentSKU: masterDriveProductID
        },
        success: function (data) {
            if (data && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                displayMessage(data, listName, button, iconEmpty, iconFilled);
                if (isWishlist && iconEmpty && iconEmpty.length && !removeRecipeId) {
                    iconEmpty.data("recipeId", recipeObj.recipe.id);
                }
                if (listType === 11 && data.productListQuantityData && $(".b2b-active-project-quantity").length) {
                    $(".b2b-active-project-quantity").trigger("count:update", data.productListQuantityData);
                }
            }
        },
        error: function (err) {
            displayMessage(err, listName, button, iconEmpty, iconFilled);
        }
    });
}

/**
 * Handles print image generation and returns promise object
 * @param {Object} customizerInstance - customizer instance
 * @returns {Promise} promise object
 */
function getImage(customizerInstance) {
    return customizerInstance.captureImage();
}

/**
 * Initialize page events when customizer instance is ready
 * @param {Object} customizerInstance - customizer instance
 */
function initEvents(customizerInstance) {
    $(document).on("click", SELECTORS.ADD_TO_CART_BUTTON, function () {
        $("body").trigger("product:beforeAddToCart", this);
        getRecipe(customizerInstance).then((recipe) => {
            addRecipeToCart(recipe);
        }, () => {
            $.spinner().stop();
        });
    });

    $("body").on("product:drivePrint", function () {
        $(".cz__group-header[aria-expanded='false']").addClass("print-expanded").trigger("click");
        if ($(".slide-customizer").length > 0) {
            getImage(customizerInstance).then(image => {
                $(".pdp-images-print-container .product-slider-image").attr("src", image);
                setTimeout(window.print, 100);
            });
        } else {
            setTimeout(window.print, 100);
        }
    });

    window.onafterprint = function () {
        setTimeout(function () {
            $(".print-expanded").trigger("click").removeClass("print-expanded");
        }, 100);
    };

    // Save recipe to custom list (wishlist, save for later, etc)
    $(document).on("click", ".add-to-wish-list-drive-customizer,.add-to-list-drive-customizer,.add-to-gift-registry-drive-customizer", function (e) {
        e.preventDefault();
        var $element = $(this);

        if ($(this).hasClass("wishlist-add")) {
            var gtmWishlistContainer = $(this).closest(".product-detail").find(".gtm-add-to-wishlist-container");
            var gtmAddToWishlistObj = gtmWishlistContainer.find(".gtm-add-to-wishlist").attr("data-add-to-wishlist");
            $("body").trigger("gtm:standartEvent", {
                event: "add_to_wishlist",
                data: JSON.parse(gtmAddToWishlistObj)
            });
        }

        $.spinner().start();
        getRecipe(customizerInstance).then((recipe) => {
            addRecipeToList(recipe, $element);
        });
    });

    $(document).on("click", ".btn-change-quantity-drive-customizer", function (e) {
        e.preventDefault();

        var meta = getWidgetMeta();
        var $qtySelector = getQuantitySelector();
        var currentValue = parseInt($qtySelector.val(), 10);
        var maxValue = parseInt($qtySelector.data("max-qty"), 10);
        var url = $qtySelector.data("url");
        var newValue = +currentValue;
        if ($(this).hasClass("btn-increase-quantity") && maxValue < 100 && maxValue > currentValue) {
            newValue += 1;
        }
        if ($(this).hasClass("btn-decrease-quantity") && currentValue > 1) {
            newValue -= 1;
        }
        if ($(this).hasClass("btn-decrease-quantity") && currentValue == 1) {
            return;
        }
        if (newValue == 1) {
            $(this).closest(".product-detail").find(".btn-decrease-quantity").addClass("disabled");
        } else {
            $(this).closest(".product-detail").find(".btn-decrease-quantity").removeClass("disabled");
        }
        $qtySelector.val(newValue);
        var storedSkuDataStr = meta.get("skuData");

        if (storedSkuDataStr) {
            var storedSkuData = JSON.parse(storedSkuDataStr);
            var requestData = storedSkuData;
            requestData.quantity = newValue;
            handleChangeSkuAjax(url, requestData);
        }
    });

    $(document).on("click", ".cz__image-option-custom-layout", function () {
        var $pdpImageSlider = $(SELECTORS.MAIN_IMAGES_CONTAINER).find(".primary-images-carousel .slick-slider");
        var $customizerSlide = $(SELECTORS.CUSTOMIZER_SLIDE).closest(".slick-slide");
        $pdpImageSlider.slick("slickGoTo", $customizerSlide.data("slickIndex"));
    });
}

/**
 * Sets variant image on page load if the user is editing a recipe
 */
function setImage() {
    var meta = getWidgetMeta();
    var recipeID = meta.get("editedRecipe");

    if (recipeID) {
        $(".pdp-images-change-preview-container").find("button").trigger("click");
    }
}

document.addEventListener("DOMContentLoaded", function initializeWidget() {
    if (window.CustomizerWidget) {
        var options = getWidgetOptions();

        var isPageDesignerPDP = $(".product-detail-page").length > 0;

        // Initialize drive commerce widget
        window.CustomizerWidget.createWidget(options)
            .then((customizerInstance) => {
                initEvents(customizerInstance);
                setImage();
                if (!isPageDesignerPDP) {
                    // adds workroom modal listeners
                    workroom.addToCart();
                    workroom.addToMaterialList();
                    workroom.removeFromMaterialList();
                }
            });
    }
});
